import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'mx',
    alia: 'mx',
    region: 'Mexico',
    regionText: 'México',
    language: 'Spain',
    languageText: 'Español',
    appId: 24,
    acceptLanguage: 'es-MX,es;q=0.9',
};
export default theLocale;
